import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import store from './store/index';
import routes from './routes';

import {api} from "./config";

const router = new VueRouter({
  mode: 'history',
  root:  '/apps',
  routes
});

router.beforeEach(async (to, from, next) => {
  // just logged in: localStorage has token, but state does not have auth user
  if (to.meta.requiresAuth) {
    let authUser = store.getters.getAuthUser;
    let isAuth = (authUser !== null && authUser.email_verified_at) ? true : false;
    if (!isAuth) {
      axios.get(api.frontCsrfCookie, { withCredentials: true }).then(() => {
        axios.get(api.frontAuthUser, { withCredentials: true })
        .then((frontresp) => {
            store.dispatch('setAuthUser', frontresp.data)
            
            return next();
        }).catch(err => {
            store.dispatch('unsetAuthUser')
            return next();
        });
      });

    } else {
      return next();
    }

  } else {
    return next();
  }

});

export default router;
